import { createSlice } from "@reduxjs/toolkit";

const loaderInitialState = {
  loading: false,
  apiCount: 0,
  error: false,
  traceID: "",
  timeOut: false,
  internetDown: false,
  reason: "",
};

export const loaderSlice = createSlice({
  name: "loader",
  initialState: loaderInitialState,
  reducers: {
    startLoader: (_, { payload = 1 }) => ({
      loading: true,
      apiCount: payload,
      error: false,
      traceID: "",
    }),

    stopLoader: (state) => ({
      ...state,
      loading: false,
      apiCount: 0,
      error: false,
    }),

    apiComplete: (state, { payload = 1 }) => ({
      ...state,
      apiCount: state.apiCount - payload,
      loading: !!(state.apiCount - payload > 0),
    }),

    apiError: (state, { payload = "" }) => ({
      ...state,
      loading: false,
      error: true,
      traceID: payload,
    }),

    timeOutError: (state, { payload = "" }) => ({
      ...state,
      loading: false,
      timeOut: true,
      reason: payload,
    }),

    internetDown: (state, { payload = "" }) => ({
      ...state,
      loading: false,
      internetDown: true,
      reason: payload,
    }),
  },
});

export const {
  startLoader,
  stopLoader,
  apiComplete,
  apiError,
  timeOutError,
  internetDown,
} = loaderSlice.actions;

export default loaderSlice.reducer;
